import axios from "../utility/authAxios";
import { API_VERSION, AGENT_SERVICE_PATH } from "../config/axios";
import { setHttpParams } from "../utility/utils";

/**************** User Roles API *****************************/
// get all user roles list
export const getAgentAdmins = async (params = {}) => {
    params = setHttpParams(params);
    return axios.get(
        API_VERSION + `/${AGENT_SERVICE_PATH}/cms/search?${params}`
    );
};

export const getAgentUsers = async (params = {}) => {
    params = setHttpParams(params);
    return axios.get(
        API_VERSION + `/${AGENT_SERVICE_PATH}/customer/search?${params}`
    );
};

export const checkAgentUserExist = async (params = {}) => {
    params = setHttpParams(params);
    return axios.get(
        API_VERSION + `/${AGENT_SERVICE_PATH}/customer/check?${params}`
    );
};

export const generateAgentOtp = async (data) => {
    return axios.post(
        API_VERSION + `/${AGENT_SERVICE_PATH}/otp/generate`,
        data
    );
};
export const verifyAgentOtp = async (data, ref) => {
    if(ref == undefined){
        throw new Error("OTP reference is required");
    }
    return axios.post(
        API_VERSION + `/${AGENT_SERVICE_PATH}/otp/verify/${ref}`,
        data
    );
};
export const resendAgentOtp = async () => {
    return axios.post(
        API_VERSION + `/${AGENT_SERVICE_PATH}/otp/verify/${ref}`,
        {}
    );
};

export const registerAgentUser = async (params) => {
    return axios.post(
        API_VERSION + `/${AGENT_SERVICE_PATH}/customer/register`,
        params
    );

};
